import React from 'react';

/**
 * Consistent Apply / Clear filter buttons for pages using useFilterBar.
 *
 * @param {Function} onApply        - Pushes draft filters to URL
 * @param {Function} onClear        - Resets all filters to defaults
 * @param {boolean}  isDirty        - Draft differs from applied (enables Apply)
 * @param {boolean}  hasActiveFilters - Any non-default filters applied
 */
export default function FilterActions({ onApply, onClear, isDirty, hasActiveFilters }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onApply}
        disabled={!isDirty}
        className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
          isDirty
            ? 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm'
            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
        }`}
      >
        Apply Filters
      </button>
      {(hasActiveFilters || isDirty) && (
        <button
          type="button"
          onClick={onClear}
          className="px-4 py-2 rounded text-sm font-medium text-gray-600 hover:text-red-600 hover:bg-red-50 border border-gray-300 hover:border-red-300 transition-colors"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
}
